import { Person, AccountTree } from '@mui/icons-material';
import { Button, Modal } from '@mui/material';
import { Drawer, Dropdown, message } from 'antd';
import { filter, get } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
//  -- Components ---------------------
import { CaretDownOutlined } from "@ant-design/icons";
import { CheckCircle, Close } from '@mui/icons-material';
import BadgeButton from '../../BadgeButton';
import SpinLoader from 'components/Loader/SpinLoader';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { find } from 'lodash';
import { useActivities } from 'store/activities/selectors';
import { useAllBook } from 'store/books/selectors';
import color from 'utils/constants/color';
import { graphic_activity, graphic_data } from 'utils/constants/graphic_org';
import { getNumberMask } from 'utils/lib/ebookHelper';
import GraphicAssignmentForm from './Form';

const LearnPlanWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: transparent;
    overflow: hidden;
    padding:0px !important;
`;

const CloseBtn = styled.div`
    background-color: rgb(204,80,71);
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    z-index: 1;
`;
const ContollButton = styled.button`
    background: linear-gradient(to right,${color.indigo500}, ${color.indigo600});
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 25px;
    color: white;
    z-index: 1;
    padding: 3px;
    margin-bottom:12px;
    margin-top:8px;
    margin-left:12px;
}
`;
const AssignButton = styled.button`
    background-image: linear-gradient(to right,${p => p.active ? color.greentrue : color.indigo500}, ${p => p.active ? color.greentrue : color.indigo600});
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 25px;
    color: white;
    z-index: 1;
    padding: 3px;
    margin-bottom:12px;
    margin-top:8px;
    position: absolute;
    bottom: -10px;
    border-radius: 12px;
    padding: 12px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
}
`;

const AssignmentPlan = styled.button`
    // background-image: linear-gradient(to right,${COLOR.indigo500}, ${COLOR.indigo600});
    background-color: #020A52;
    // border: none;
    border:1px solid #020A52;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 12px;
    margin-top:10px;
    margin-bottom: 10px;

    @media only screen and (max-width:  1025px){
      margin-top:5px;
    }
}
`;
const AssignmentPlanInner = styled.div`
  display: flex;
  // flex-direction: column;
  flex-direction:row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid #fff;
  padding-left: 6px;
  padding-right: 6px;
`;


const Items = ({ onClick = () => { }, category, assignedActivity, assignment  , getNumberMaskForPage}) => {
    const is_assigned = assignedActivity && assignedActivity.length>0;
    const onNewAssign = () => {
        onClick("create", assignment)
    }
    const openAssignedAssignment = act => {
        onClick("view", act)
    }
    const assignedAssignmentView = () => {
        return assignedActivity && assignedActivity.length > 0 ? 
            assignedActivity?.map((act, index) => ({
                key: index,
                label: `Assigned on page.${getNumberMaskForPage(act.page)}`,
                onClick: () => { openAssignedAssignment(act) }
            })) : [{
                key: 'assigned',
                label: 'Assigned'
            }];
    }
    return (<div className='myCategoryList' style={{ width: 300 }}>
        <div className="ShowDetailBnr">
            <img style={{ height: "auto" , cursor:"default" }} src={category.src} alt="" />
            {is_assigned ?
                <Dropdown
                    menu={{ items: assignedAssignmentView() }}
                    trigger={['click']}>
                    <AssignButton
                        active
                        style={{ bottom: "24px" }}
                    >
                        {`Assigned`}  <CaretDownOutlined style={{ fontSize: '18px', marginLeft: '6px', color: "#fff" }} />
                    </AssignButton>
                </Dropdown>
                : null}
             <AssignButton
                onClick={onNewAssign}>
                Assign now
            </AssignButton>
        </div>
        <div className='categoryBtnTxt' style={{ height: "auto", paddingBottom: 10 }}>
            <div className='onway-teacher-txt' style={{ fontSize: 14, height: "auto", minHeight: 50, paddingLeft: 8 }}>
                {get(category, "description", "") || ""}
            </div>
            <div className='persionIconImg' style={{ fontSize: 8, color: "#fff" }}>
                <Person className='iconClrChange' />
                <span>{"ONE WAY EDUCATION"}</span>
            </div>
        </div>
    </div>)
}
function GraphicOrganizerAdmin({ page , chapter, hasPermission = true }) {
    const showAlert = useAlert();
    const booksAllList = useAllBook()
    const activities = useActivities();
    const AssignedActivity = useMemo(() => filter(activities, q => q.chapter == chapter  && q.createdBy == "admin" && q.activity_type=='graphic_organizer'), [activities,chapter])
    const pageAssigned = useMemo(() => filter(AssignedActivity, q => q.page == page), [AssignedActivity,page])
    const bookAssignment = useMemo(() => filter(activities, q => q.chapter == '7' && q.assignment_page != null && q.createdBy=='system' && q.activity_type=='graphic_organizer'), [activities, chapter, page])
    const getAssignment = useCallback((category) => {
        const assignment = find(bookAssignment, k => k.assignment_page == category.pageId);
        if (assignment) return assignment;
        const assignment_static = find(graphic_activity, k => k.assignment_page == category.pageId);
        return assignment_static;
    }, [bookAssignment])
    const [pageModalInfo, setPageModalInfo] = React.useState({
        open: false,
        src: ''
    });
    const dispatch = useDispatch()
    /** assignment area */
    const [activityDrawer, toggleActivityDrawer] = useState(false);
    const [activityData, setActivityData] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [loading,setLoading] = useState(false)

    useEffect(() => {
        if (!activityDrawer) {
            setActivityData({})
        }
    }, [activityDrawer])


    const handleAssignment = (type, assignment) => {
        setActivityData(assignment)
        if (!assignment) {
            showAlert("Some data is missing. Please reload the page.","error")
            return;
        };
        if (type === "create") {
            toggleActivityDrawer(true);
            assignment.page = page;
            assignment.chapter = chapter;
            assignment.bookId = chapter;
            setActivityData(assignment);
            handleClose()
        } else {
            // navigate(`/ebook?chapter=${assignment.chapter || assignment?.data.chapter || '7'}&page=${assignment.assigned_on_page}&activity=null&quiz=null`)
            handleClose()
        }
    }

  
    const onCloseDrawer = () => {
        toggleActivityDrawer(false)
        setActivityData({})
    }

    /** assignment area end */


    useEffect(() => {
        if (pageModalInfo?.open) {
            document.documentElement.style.overflow = "hidden";
        }
        return () => {
          document.documentElement.style.overflow = "auto";
          document.body.style.overflow = "auto";
        };
      }, []);

    const getNumberMaskText = useCallback((page_id) => {
        return getNumberMask(chapter, page_id, booksAllList)
    }, [booksAllList, chapter])
    const handleOpen = (item) => setPageModalInfo({
        open: true,
    });
    const handleClose = () => setPageModalInfo({
        open: false,
        src: ''
    });
    return (
        <>
             <BadgeButton
            onClick={() => {
                if (!hasPermission) {
                    message.warning('You do not have permission to access this feature.');
                    return;
                }
                handleOpen();
            }}
            startIcon={<AccountTree />}
            showBadge={pageAssigned.length > 0}
            backgroundColor="#0891b2"
        >
             Graphic Organizers
        </BadgeButton>
        <SpinLoader dataloader={loading} />
            <Drawer
                height='100%'
                destroyOnHidden
                onClose={onCloseDrawer}
                placement='top'
                open={activityDrawer}
                key='activityNew'
                className='assignments-drawer'
            >
                <>
                    <GraphicAssignmentForm
                        pageId={page}
                        bookId={chapter}
                        pageSrc={selectedItem.src}
                        data={{}}
                        assignment={activityData}
                        onClose={() => { 
                            onCloseDrawer()
                        }}
                    />
                </>
            </Drawer>
            <Modal
                open={pageModalInfo.open}
                onClose={handleClose}
                className={"rubricsPopUp"}
                style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
                onContextMenu={e => {
                    e.preventDefault();
                }}
            >
                <LearnPlanWrapper className='teacherStrategies'>
                    <CloseBtn onClick={handleClose}>
                        <Close style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }} />
                    </CloseBtn>
                    <div className='myCategorys' style={{ height: "95vh", overflow: "auto", alignItems: "center", marginTop: 0 }}>
                        {graphic_data.map((category, index) => (<Items
                            category={category}
                            key={index + "_cat"}
                            onClick={(type,act)=>{
                                handleAssignment(type,act)
                                setSelectedItem(category)
                            }}
                            assignedActivity={filter(AssignedActivity,k=>k.assignment_page == category.pageId)}
                            assignment={getAssignment(category)}
                            getNumberMaskForPage={getNumberMaskText}
                        />))}
                    </div>

                </LearnPlanWrapper>
            </Modal>
        </>
    )
}

export default GraphicOrganizerAdmin;